/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicenseCardModule
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ClrSpinnerModule } from '@clr/angular';
import { AviCardModule, AviUsageBarModule } from 'nsx-alb-ui-components';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';

import {
    LicenseCardComponent,
    LicenseCardContentComponent,
    LicenseCardUsageComponent,
} from './components';

const licensingComponents = [
    LicenseCardComponent,
    LicenseCardContentComponent,
    LicenseCardUsageComponent,
];

/**
 * @description Angular Module for the License Card component
 * @author alextsg
 */
@NgModule({
    declarations: [
        ...licensingComponents,
    ],
    exports: [
        LicenseCardComponent,
        LicenseCardContentComponent,
    ],
    imports: [
        AviCardModule,
        AviFormsModule,
        SharedModule,
        ClrSpinnerModule,
        AviUsageBarModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LicenseCardModule {}
